import { useFallbackStorageValue } from "./fallback-storage-value";
export const useSubscriptionsList = () => {
  const {
    set: setSubscriptionList,
    value: subscriptionList
  } = useFallbackStorageValue("subscriptedList");
  return {
    setSubscriptionList,
    subscriptionList
  };
};